import { Input } from '@/lib';
import { ChangeEvent, FC, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

type CampaignDetailNameProps = {
  isEditingName: boolean;
  campaignName: string;
  onCampaignNameChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const campaignClassNames = 'max-w-[100%] text-lg font-semibold text-brand-600 leading-6 py-2';

export const CampaignDetailName: FC<CampaignDetailNameProps> = ({ isEditingName, campaignName, onCampaignNameChange }) => {
  const inputSize = useMemo(() => (campaignName.length > 60 ? 42 : campaignName.length - 2), [campaignName]);

  if (isEditingName) {
    return (
      <Input
        className={twMerge('w-fit pl-0.5 pr-4', campaignClassNames, isEditingName && 'border-brand-600 border-2')}
        wrapperClassName='max-w-[100%] w-fit'
        defaultValue={campaignName}
        onChange={onCampaignNameChange}
        size={inputSize}
      />
    );
  }

  return <h2 className={campaignClassNames}>{campaignName}</h2>;
};
